import { clientAttachmentSettingsBootstrap } from '@ms/yammer-data/dist/domains/clientAttachmentSettings/actions';
import type { ClientAttachmentSettings } from '@ms/yammer-data/dist/state/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useClientAttachmentSettingsBootstrap = (settings: ClientAttachmentSettings): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clientAttachmentSettingsBootstrap(settings));
    // oxlint-disable-next-line react/exhaustive-deps
  }, [settings]);
};
